module.exports = __webpack_public_path__ + "media/images/menu/delphinus-f18d59f52cad18bb8fd48632a2ed76ec.jpg";